import Vue from 'vue'

import firebase from 'firebase';


const state = {
  view: 'visitor',
  logged_in: false,
  logged_out: false, 
  user: false
};

const actions = {
  login( {state, commit}, { email, password }) {
    state;
    commit;
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password)
        .then((user) => {
          resolve(user);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut()
        .then(() => {
          commit('LOGOUT');
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkUserStatus({  commit }) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          commit('SET_USER', user);
          commit('SET_LOGGED_IN');
          resolve( true )
          // dispatch("registerModule")
        }
        else {
          reject('User is not logged in.');
        }
      });
    });
  },
  loggedIn({ commit }){
    commit('SET_LOGGED_IN')
  }
};

const mutations = {
  LOGOUT(state ) {
    let now = Math.round((new Date()).getTime() / 1000);
    Vue.set( state, "logged_out", now ) 
    Vue.set( state, "logged_in", false ) 
    Vue.set( state, "user", false )  
    Vue.set( state, "view", "visitor" )  
  },
  SET_LOGGED_IN( state){
    let now = Math.round((new Date()).getTime() / 1000);
    Vue.set( state, "logged_in", now ) 
  },
  SET_USER(state, user) {
    if( !user ){ return; }
    Vue.set( state, "user", {
        email: user.email, 
        uid: user.uid,
        displayName: user.displayName
      }
    ) 
    firebase.auth().currentUser.getIdTokenResult().then( a => {
      if( a.claims.role ){
        Vue.set( state.user, "role", a.claims.role ) 
        Vue.set( state, "view", a.claims.role ) 
      }
    })
  } 
};

export default {
  state,
  actions,
  mutations,
};
